import React, { useEffect, useState } from "react"
import { Switch } from "antd"

const NumericTypeSwitch = ({ selectedTextObj, updateSelectedText }) => {
    const [isChecked, setIsChecked] = useState(true)

    useEffect(() => {
        setIsChecked(selectedTextObj?.options?.numericType == "fa")
    }, [selectedTextObj])
    if (!selectedTextObj?.variable?.faValue) return

    return (
        <div className="control-section">
            <div className="style-control">
                <label>نوع عدد:</label>
                <span style={{ color: "#fff" }}>انگلیسی</span>
                <Switch
                    checked={isChecked}
                    onChange={(checked) => {
                        setIsChecked(checked)
                        updateSelectedText("options", {
                            ...selectedTextObj?.options,
                            numericType: checked ? "fa" : "en",
                        })
                    }}
                />
                <span style={{ color: "#fff" }}>فارسی</span>
            </div>
        </div>
    )
}

export default NumericTypeSwitch
